import { observer, useLocalObservable } from 'mobx-react-lite' 
import { Button, Col, DatePicker, Form, Input, Modal, Row, Select, message } from 'antd';
import React, { useEffect, useRef, useState } from 'react'; 
import { Delivery, DeliveryAE } from '@/delivery/model';
import { deliveryApi } from '@/delivery/DeliveryLegacyApi';
import { EnumConfigOption, globalStore } from '@/common/index';
import { SettingOutlined } from '@ant-design/icons';  
import { DeliveryScaleTypeOptions, SNumber } from '@/common/model'; 
import ParticipantCard from '@/delivery/components/ParticipantCard';
import TextArea from 'antd/lib/input/TextArea';
import EnumConfig from '@/components/EnumConfig/EnumConfig';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import dayjs from 'dayjs';
import moment from 'moment';
import { disabledNonFriday } from '@/domains/hooks/useFormatData';

type Props = {
     mode:number // 0-只读，1-添加，2-编辑
     delivery:Delivery
     visible:boolean 
     close:()=>void
}

type Store = {
  tempDelivery:Delivery
  currentEnumOptions:EnumConfigOption[]
  currentEnumType:SNumber
  enumConfigVisible:boolean
  draggingIndex:SNumber
}

 
const DeliveryDetail: React.FC<Props> = ({ mode,delivery,visible,close}) => {  

  const store = useLocalObservable<Store>(() => ({
    tempDelivery: delivery?{...delivery} : new Delivery(),
    currentEnumOptions: null,
    currentEnumType:null,
    enumConfigVisible: false,
    draggingIndex:null
  })); 




  useEffect(() => {
    // 在  store.tempDelivery 更新后执行的逻辑
    console.log(' store.tempDelivery updated:',  store.tempDelivery);
  }, [ store.tempDelivery]);

  if(!store.tempDelivery){
    return null;
  }

    const moveListItem = (dragIndex: number, hoverIndex: number) => {
      
        const { members: userInfos } =  store.tempDelivery;
      
        // 取出被拖动的元素
        const draggedItem = userInfos[dragIndex];
        
        // 从原数组中移除被拖动的元素
        const updatedUserInfos = userInfos.filter((item, index) => index !== dragIndex);
        
        // 将被拖动的元素插入新的位置
        updatedUserInfos.splice(hoverIndex, 0, draggedItem);
        
        // 更新状态
        store.tempDelivery.members = updatedUserInfos; 
      
    };

    const handleFormDataChange = (
      propName: string,
      value: string | string[] | moment.Moment | number | null
    ): void => {
      console.log("props is", propName);
      if (propName === 'date' && value) {
        // 如果是日期选择器的变化
        const dateString = (value as moment.Moment).format('YYYY-MM-DD'); // 将 moment 对象格式化为字符串
         store.tempDelivery.finishDate = dateString; // 将格式化后的日期字符串赋值给  store.tempDelivery.finishDate
      } else if (propName === 'userInfos' && value && value[0]) {
        // 如果是用户信息的变化
         store.tempDelivery.members.push(value[0]);
        console.log(value[0]+" is pushed into temp members");
      } else {
        // 其他情况直接赋值
         store.tempDelivery[propName] = value;
      }
    };
 
    const handleConfirm = async () => {
      if (! store.tempDelivery.name) {
        message.warning('请输入交付项名称', 1)
        return
      }
      if ( store.tempDelivery.taskScaleType === undefined) {
        message.warning('请输入项目规模', 1)
        return
      }
      if (! store.tempDelivery.morningMeetingId) {
        message.warning('请输入跟进晨会名称', 1)
        return
      }
      if (! store.tempDelivery.taskTypeId) {
        message.warning('请选择交付类型', 1)
        return
      } 
      if (! store.tempDelivery.taskStatusId) {
        message.warning('请选择交付项状态', 1)
        return
      }
      if (
        mode !== 1 &&
        (!store.tempDelivery.members || store.tempDelivery.members.length <= 0)
      ) {
        message.warning('请选择交付项执参加者', 1)
        return
      }

      const id = await deliveryApi.addOrEditDelivery( store.tempDelivery);

      if(id>=0){
          message.info(mode===1? "添加交付项成功！":"更新交付项成功！");
          close()
      }
      else{
          message.info(mode===1? "添加交付项失败！":"更新交付项失败！");
      }
    }
   
    
    const showEnumConfigManager = (
      type: 'meeting' | 'type' | 'bizType' | 'status'
    ): void => {
      switch(type){
        case 'meeting': store.currentEnumOptions = globalStore.enumConfigs.meetingOptions; store.currentEnumType = 1; break;
        case 'type': store.currentEnumOptions = globalStore.enumConfigs.taskTypeOptions;  store.currentEnumType = 5;break;
        case 'bizType': store.currentEnumOptions = globalStore.enumConfigs.bizLineOptions;  store.currentEnumType = 2;break;
        case 'status':  store.currentEnumOptions = globalStore.enumConfigs.taskStatusOptions;  store.currentEnumType = 4; break;
      } 
      store.enumConfigVisible = true
    }

    const onDrop = (dragIndex: number, hoverIndex: number) => { 
      const updatedUserInfos = [... store.tempDelivery.members];
      const [draggedItem] = updatedUserInfos.splice(dragIndex, 1);
      updatedUserInfos.splice(hoverIndex, 0, draggedItem);
       store.tempDelivery.members = updatedUserInfos; 
    };

    return (
        <Modal 
          width={700}
          title={ mode === 0 ? '周交付详情': (mode ===1 ? '创建新的周交付':'编辑周交付')}
          visible={visible}
          centered
          okButtonProps={{
            size: 'middle'
          }}
          cancelButtonProps={{
            size: 'middle'
          }}
          onOk={handleConfirm}
          onCancel={close}
          wrapClassName="add-deliver"
        >
           <DndProvider backend={HTML5Backend}>
           <Row>
              <Col span={24}>
               <div style={{marginBottom: '0px'}}>
                    <Input
                      value={ store.tempDelivery.name? store.tempDelivery.name:''}
                      placeholder="请总结交付项的名称"
                      className='title-input'
                      onChange={(e) => handleFormDataChange('name', e.target.value)}
                    />
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={12}> 
                <Form labelCol={{ span: 5 }} wrapperCol={{ span: 15 }} style={{marginTop:'10px', borderRight:'1px solid #ddd'}}>
                  <Form.Item label='规模' required>
                    <Select
                      value={ store.tempDelivery.taskScaleType}
                      placeholder="请选择任务规模"
                      onChange={(e) => handleFormDataChange('taskScaleType', e)} 
                      style={{ width: '100%', height:'30px'}}
                    >
                      {DeliveryScaleTypeOptions.map((option) => (
                        <Select.Option key={option.value} value={option.value}>
                          {option.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item  label='截止' > 
                    <DatePicker
                      placeholder="请选择截止日期"
                      style={{ width: '100%' }}
                      inputReadOnly
                      disabledDate={disabledNonFriday}
                      value={
                        store.tempDelivery.finishDate
                          ? dayjs(store.tempDelivery.finishDate, 'YYYY-MM-DD')
                          : undefined
                      }
                      format="YYYY-MM-DD"
                      onChange={(e) => {
                        if (e != null && e.day() !== 5) {
                          return
                        }
                        handleFormDataChange(
                          'date',
                          e ? moment(e.format('YYYY-MM-DD')) : null,
                        )
                      }}
                    />
                  </Form.Item>
                  <Form.Item label='晨会' required>
                    <div className="flex items-center" style={{ width: '100%' }}>
                      <Select
                        value={ store.tempDelivery.morningMeetingId}
                        placeholder="请选择跟进晨会"
                        className='no-border-select'
                        onChange={(e) => handleFormDataChange('meetingName', e)}
                      >
                        {
                          
                         globalStore.enumConfigs.meetingOptions
                          .filter((opt) => opt.deleteFlag == 0)
                          .map((option: EnumConfigOption) => (
                            <Select.Option key={option.id} value={option.id}>
                              {option.name}
                            </Select.Option>
                          ))
                        }
                      </Select>
                      <Button
                        className="flex-shrink-0"
                        style={{ marginLeft: 5 , border:'none'}} 
                        icon={<SettingOutlined />} 
                        onClick={() => {
                          showEnumConfigManager('meeting')
                        }}
                      />
                    </div>
                  </Form.Item>
                  <Form.Item label='类型' required>
                    <div className="flex items-center">
                      <Select
                        className='no-border-select'
                        value={ store.tempDelivery.taskScaleType}
                        placeholder="请选择交付类型"
                        onChange={(e) => handleFormDataChange('type', e)}
                      >
                        {globalStore.enumConfigs.taskTypeOptions
                          .filter((opt) =>  opt.deleteFlag == 0)
                          .map((option: EnumConfigOption) => (
                            <Select.Option key={option.id} value={option.id}>
                              {option.name}
                            </Select.Option>
                          ))}
                      </Select>
                      <Button
                        className="flex-shrink-0"
                        style={{ marginLeft: 5 , border:'none'}} 
                        icon={<SettingOutlined />}
                        // icon={<PlusOutlined />}
                        onClick={() => {
                          showEnumConfigManager('type')
                        }}
                      />
                    </div>
                  </Form.Item> 
                  <Form.Item label='状态' required>
                    <div className="flex items-center">
                      <Select
                        value={ store.tempDelivery.taskStatusId}
                        placeholder="请设置交付状态"
                        className='no-border-select'
                        onChange={(e) => handleFormDataChange('status', e)}
                      >
                        {globalStore.enumConfigs.taskStatusOptions
                          .filter((opt) => opt.deleteFlag == 0  )
                          .map((option: EnumConfigOption) => (
                            <Select.Option key={option.id} value={option.id}>
                              {option.name}
                            </Select.Option>
                          ))}
                      </Select>
                      <Button
                        className="flex-shrink-0"
                        style={{ marginLeft: 5 , border:'none'}} 
                        icon={<SettingOutlined />}
                        // icon={<PlusOutlined />}
                        onClick={() => {
                          showEnumConfigManager('status')
                        }}
                      />
                    </div>
                  </Form.Item> 
                </Form>
              </Col>
              <Col span={12} style={{paddingLeft:40,paddingTop:10}}>
                <Form className='member-select-form'>
                  <Form.Item
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 20 }}
                    className='add-member-select'
                  >
                    <Select
                      showSearch
                      className='member-select' 
                      placeholder="添加参与人"
                      filterOption={(input, option) =>{

                            const optionUser = globalStore.userMap.get(parseInt(option?.value as string));
                            return `${optionUser?.userName}${optionUser?.userNamePinyin}${optionUser?.nickName}${optionUser?.nickNamePinyin}`
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          } 
                      }
                      value={null}
                      // onSearch={handleSearch}
                      onChange={(e) => {
                        handleFormDataChange('userInfos', [e] as any)
                      }}
                    >
                      {
                        globalStore.userMap.values() && Array.from(globalStore.userMap.values()).filter(
                          (user) =>{ 
                            return ! store.tempDelivery.members.includes(user.id)
                          }
                        )
                        .map((userInfo) => {
                          return(
                          <Select.Option
                            key={userInfo.id}
                            value={userInfo.id}
                          >
                            {userInfo.userName}
                          </Select.Option>
                        )})
                      }
                    </Select>
                  </Form.Item>
                  <Form.Item
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 20 }}
                  >
                    <div className="member-container">
                      { 
                       store.tempDelivery.members.map((item, index)=>{
                          return ( 
                            <ParticipantCard
                                key={item}
                                index={index}
                                userId={item+""}
                                onDrop={onDrop}
                                moveListItem={moveListItem}
                                onRemove={() => {
                                   store.tempDelivery.members =
                                    store.tempDelivery.members.filter((value)=>{return value === item})
                                }}
                                isDragging={index === store.draggingIndex}
                                onDragStart={() => store.draggingIndex = index}
                                onDragEnd={() => store.draggingIndex = null}
                              /> 
                          )
                       }) 
                      }
                    </div>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
            <Row className='link-row'>
              <Col span={24}>
                  <Form.Item label='文档'>
                      <Input
                            value={ store.tempDelivery.attachmentUrl as string}
                            className='add-link'
                            placeholder="添加文档链接"
                            onChange={(e) => {
                              handleFormDataChange('taskUrl', e.target.value)
                            }}
                        />
                  </Form.Item> 
              </Col>
            </Row>
            <Row className='desc-row'>
              <Col span={24}>
                  <Form.Item label='说明' className='desc-textarea'>
                      <TextArea
                        autoSize={{ minRows: 2, maxRows: 4 }}
                        value={ store.tempDelivery.remarks as string}
                        className='add-desc'
                        placeholder="添加更多说明" 
                        onChange={(e) =>
                          handleFormDataChange('remarks', e.target.value)
                        }
                      />
                  </Form.Item> 
              </Col>
            </Row>
            <EnumConfig 
                    visible ={store.enumConfigVisible}
                    options={store.currentEnumOptions} 
                    type={store.currentEnumType} 
                    onClose={()=>{store.enumConfigVisible=false}}
                       />
            </DndProvider>
        </Modal>
      )
}
  
  export default observer(DeliveryDetail)
